import Model from 'flarum/common/Model';
export default class SupporterClub extends Model {}
SupporterClub.prototype.name = Model.attribute('name');
SupporterClub.prototype.description = Model.attribute('description');
SupporterClub.prototype.foundedAt = Model.attribute('foundedAt');
SupporterClub.prototype.email = Model.attribute('email');
SupporterClub.prototype.phone = Model.attribute('phone');
SupporterClub.prototype.address = Model.attribute('address');
SupporterClub.prototype.websiteUrl = Model.attribute('websiteUrl');
SupporterClub.prototype.facebookUrl = Model.attribute('facebookUrl');
SupporterClub.prototype.instagramUrl = Model.attribute('instagramUrl');
SupporterClub.prototype.twitterUrl = Model.attribute('twitterUrl');
SupporterClub.prototype.imagePath = Model.attribute('imagePath');
SupporterClub.prototype.latitude = Model.attribute('latitude');
SupporterClub.prototype.longitude = Model.attribute('longitude');
SupporterClub.prototype.isActive = Model.attribute('isActive');
SupporterClub.prototype.tagId = Model.attribute('tagId');
SupporterClub.prototype.adminGroupId = Model.attribute('adminGroupId');
SupporterClub.prototype.tag = Model.hasOne('tag');
SupporterClub.prototype.adminGroup = Model.hasOne('adminGroup');
flarum.reg.add('nagusi-match-ratings', 'common/models/SupporterClub', SupporterClub);